/**
 * Brand Configuration - Single Source of Truth
 *
 * Change these values to update the brand name, emails, and site URL
 * across the entire frontend application. All components import from
 * here instead of hardcoding the brand name.
 *
 * For static files (index.html, robots.txt) that cannot use JS imports,
 * set the REACT_APP_BRAND_NAME env var in a .env file at frontend root.
 */
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'NovelDay';

export const BRAND_EMAIL = process.env.REACT_APP_BRAND_EMAIL || 'support@novelday.net';

export const BRAND_LEGAL_EMAIL = process.env.REACT_APP_BRAND_LEGAL_EMAIL || 'dmca@novelday.net';

/**
 * Public Discord community invite. Surfaced in the footer, the Discussions
 * sidebar, and the author dashboard Promote tab. Override via
 * REACT_APP_DISCORD_INVITE_URL in a .env file at frontend root.
 */
export const DISCORD_INVITE_URL = process.env.REACT_APP_DISCORD_INVITE_URL || 'https://discord.gg/fYp32jYFgd';

/**
 * Current Terms of Service version. Sent to the backend at registration and
 * publish time so the server can record which terms version the user agreed
 * to (audit trail for DMCA / contract disputes). Bump this whenever the Terms
 * are materially updated — the matching app.terms.version property on the
 * backend must be bumped in lockstep.
 */
export const TERMS_VERSION = process.env.REACT_APP_TERMS_VERSION || '2026-07-18';
